import { render } from "./add_pediatrics_procedures_modal.vue?vue&type=template&id=1c646d0a&scoped=true"
import script from "./add_pediatrics_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_pediatrics_procedures_modal.vue?vue&type=script&lang=js"

import "./add_pediatrics_procedures_modal.vue?vue&type=style&index=0&id=1c646d0a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c646d0a"]])

export default __exports__